export const useTimeoutFn = (cb: () => void, delay: number, autostart: boolean = false) => {
  let timerId: number | undefined;
  let startTime: number;
  let remaining = delay;

  const pause = () => {
    window.clearTimeout(timerId);
    timerId = undefined;
    remaining -= Date.now() - startTime;
  };

  const resume = () => {
    if (timerId) {
      return;
    }

    startTime = Date.now();
    timerId = window.setTimeout(cb, remaining);
  };

  // just for naming
  const start = () => resume();
  autostart && resume();

  return { start, pause, resume };
};
